import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { CartComponentStore } from 'cart-data';
import { RenderInItemResultLayoutDirective } from 'products-ui';
import { CartItemQuantitySelectorComponent } from '../../../../common/cart-item-quantity-selector';
import { WireCutCustomLengthSelectorComponent } from '../../wire-cut-custom-length-selector/wire-cut-custom-length-selector.component';
import { WireCutItemResultLayoutComponentsProviderComponentBase } from '../WireCutItemResultLayoutComponentsProviderComponentBase';

@Component({
  selector: 'ideal-wire-cut-item-result-layout-components-provider',
  imports: [RenderInItemResultLayoutDirective, CartItemQuantitySelectorComponent, WireCutCustomLengthSelectorComponent],
  standalone: true,
  templateUrl: './wire-cut-item-result-layout-components-provider.component.html',
  styleUrl: './wire-cut-item-result-layout-components-provider.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [CartComponentStore],
})
export class WireCutItemResultLayoutComponentsProviderComponent extends WireCutItemResultLayoutComponentsProviderComponentBase {
  protected readonly isCustomCut = computed(() => this.itemId()?.options.has('Z') ?? false);
}
